import { StepIconBaseStatus } from "../StepBase";

export const getIndicatorState = (currentPosition: number, currentStep: number): StepIconBaseStatus => {
  if (currentStep > currentPosition) {
    return "complete";
  } else if (currentStep === currentPosition) {
    return "current";
  } else {
    return "incomplete";
  }
};